'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function RecommendationPreferences() {
  const router = useRouter();
  const [disabled, setDisabled] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    setDisabled(document.cookie.split(';').some((part) => part.trim() === 'recommendations_disabled=1'));
  }, []);

  function update(disable: boolean) {
    document.cookie = 'recent_views=; Max-Age=0; Path=/; SameSite=Lax';
    document.cookie = `recommendations_disabled=${disable ? '1' : ''}; Max-Age=${disable ? 31536000 : 0}; Path=/; SameSite=Lax`;
    setDisabled(disable);
    setMessage(disable ? 'История удалена. Персональные рекомендации отключены в этом браузере.' : 'Рекомендации включены. История начнёт формироваться при новых просмотрах товаров.');
    router.refresh();
  }

  return <section className="mt-8 rounded-xl border border-gray-200 p-5" aria-label="Управление рекомендациями">
    <h2 className="text-xl font-semibold">Управление рекомендациями</h2>
    <p className="mt-2">Настройка действует в этом браузере. Очистка всех cookie сбрасывает её.</p>
    <button type="button" onClick={() => update(!disabled)} className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-white">
      {disabled ? 'Включить рекомендации' : 'Отключить рекомендации и удалить историю'}
    </button>
    <p className="mt-3" role="status">{message}</p>
  </section>;
}
